import {
  Box,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  ListItem,
  useTheme,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import ArrowLeftSVG from "../../../../../media/images/icons/arrow-left";

interface Props {
  icon?: JSX.Element;
  title: string;
  path: string;
}

export default function CustomListItem({ icon, title, path }: Props) {
  const theme = useTheme();

  const navigate = useNavigate();

  return (
    <ListItem
      sx={{
        "& .MuiButtonBase-root": {
          direction: "rtl",
          display: "flex",

          justifyContent: "space-between",
        },
        "& .MuiListItemIcon-root": {
          minWidth: 0,
        },
      }}
      disablePadding
    >
      <ListItemButton
        onClick={() => navigate(path)}
        sx={{
          borderRadius: "10px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "5px",
            fontWeight: "600",
          }}
        >
          {icon}
          <ListItemText
            sx={{
              fontWeight: "600",
            }}
            primary={title}
          />
        </Box>
        <ListItemIcon>
          <ArrowLeftSVG color={theme.palette.textColor.main} size={18} />
        </ListItemIcon>
      </ListItemButton>
    </ListItem>
  );
}
